import React from 'react';
import { Link } from 'react-router-dom';
import { useFeaturedMarketContext } from '../contexts/MarketContext';

import closeIcon from '../assets/x-social-media-white-icon.svg';
import shareIcon from '../assets/globe.svg';
import sendIcon from '../assets/telegram-white-icon.svg';
import swapIcon from '../assets/g7-logo-full.svg';

const FeaturedMarketCard: React.FC = () => {
  const { featuredMarket } = useFeaturedMarketContext();
  const market = featuredMarket;

  return (
    <Link to={`/token/${market.ContractAddress}`} className="market-card-link">
      <div className="featured-market-card">
        <img src={`../game-images/${market.LogoUrl}`} alt={market.Name} className="featured-market-image" />
        <span className="percentage-change">
          {market.PercentageChange > 0 ? '+' : ''}
          {market.PercentageChange.toFixed(2)}% {market.PercentageChange > 0 ? '↑' : '↓'}
        </span>
        <div className="featured-market-content">
          <div className="featured-market-header">
            <div className="creator-info">
              <span className={`percentage ${market.PercentageChange >= 0 ? 'positive' : 'negative'}`}>
                Price: {market.CurrentPrice} ({market.PercentageChange >= 0 ? '+' : ''}{market.PercentageChange.toFixed(2)}%)
              </span>
            </div>

            <div className="featured-market-actions">
              <img src={closeIcon} alt="Close" className="action-icon" />
              <img src={shareIcon} alt="Share" className="action-icon" />
              <img src={sendIcon} alt="Send" className="action-icon" />
            </div>
          </div>
          <h3 className="featured-market-title">{market.Name} ({market.Symbol})</h3>
          <p className="featured-market-description">{market.Description}</p>
          <p className="market-cap">Market Cap: ${market.MarketCap.toLocaleString()}</p>
          <div className="listed-on-swap">
            <img src={swapIcon} alt="G7 Swap" />
            - Listed on G7 Swap
          </div>
        </div>
      </div>
    </Link>
  );
};
export default FeaturedMarketCard;